import { authRoles } from '@/core/constants'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN } = authRoles

const Sales = () =>
  import(/* webpackChunkName: "sales-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/sales',
    name: 'sales',
    component: Sales,
    meta: {
      title: 'Sales',
      auth: {
        roles: [ADMIN],
        redirect: '/auth/login',
        forbiddenRedirect: '/403',
      },
    },
  },
]
